<template>
  <div>
    <div class="desktop" style="margin-top: 63px; padding-left: 30px; padding-right: 30px;">
      <div class="about-head-title">
        <h1>회사소개</h1>
      </div>
      <section class="about-hero">
        <div class="main-title-wrapper">
          <span>아이오는 혼자서도
            <br>잘 사는 방법을 연구합니다
          </span>
        </div>
      </section>
      <section class="about-description">
        <div class="about-description-wrapper">
          <div class="about-description-container">
            <h2>싱글. 자취. 원룸. 혼삶.
              <br>그 어떤 이름이든지
            </h2>
            <p>1인 가구는 점점 늘어나고 있고 앞으로도 폭발적으로 증가할 예정이죠.
              <br>그런데 우리는 이러한 삶의 방식, 혹은 경제적, 물리적인 이유로 불편함을 감수하며
              <br>생활하지는 않았나요? 혼자 산다고, 이제 곧 이사 갈 테고, 비용이 많이 들고,
              <br>설치하기 번거로우니까.우리는 이런 걱정 없이 생활의 불편을 해소하고
              <br>누구나 소유하고 활용할 수 있는 제품을 연구합니다.
            </p>
          </div>
          <div class="about-description-container">
            <h2>더 나은 1인의 삶을 위해
              <br>아이오는 시작되었습니다
            </h2>
            <p>아이오는 1인 가구를 위한 ‘제품’을 만드는 회사가 아닙니다.
              <br>우리는 우리가 만드는 제품으로 1인의 삶이 쉽고 간결해지기를 바랍니다.
              <br>나아가 우리들 개개인이 더욱 더 가치있고 주체적인 삶을 살기를 희망합니다.
            </p>
          </div>
          <div class="about-description-container">
            <h2>고객지원</h2>
            <p>02-6212-9272
              <br>help@switcher.co.kr
              <br>MON-THU 10:00 - 18:00
            </p>
          </div>
        </div>
      </section>
      <section class="about-bottom">
        <div>
          <p>아이오와 더 긴밀히 소통하고 싶다면</p>
          <a href="https://www.facebook.com/switcher.io/" target="_blank">
            <img src="@/assets/footer/facebook.png" alt>
          </a>
          <a href="https://cafe.naver.com/switcherofio" target="_blank">
            <img src="@/assets/footer/naver-cafe.png" alt>
          </a>
        </div>
        <div>
          <p>아이오의 일상이 궁금하다면</p>
          <a href="https://www.instagram.com/smarthome_io/" target="_blank">
            <img src="@/assets/footer/instagram.png" alt>
          </a>
        </div>
        <div>
          <p>제품 체험 중 궁금한 점이 생기면</p>
          <a href="https://pf.kakao.com/_uuXmV" target="_blank">
            <img src="@/assets/footer/kakao-talk.png" alt>
          </a>
        </div>
      </section>
    </div>
    <div class="mobile" style="margin-top: 63px;">
      <section class="m-about-hero">
        <h1>회사소개</h1>
        <p>아이오는 혼자서도
          <br>잘 사는 방법을 연구합니다
        </p>
      </section>
      <section class="m-about-description-wrapper">
        <div class="m-about-description-container">
          <h2>싱글. 자취. 원룸. 혼삶
            <br>그 어떤 이름이든지
          </h2>
          <p>1인 가구는 점점 늘어나고 있고
            <br>앞으로도 폭발적으로 증가할 예정이죠.
            <br>그런데 우리는 이러한 삶의 방식,
            <br>혹은 경제적, 물리적인 이유로 불편함을
            <br>감수하며 생활하지는 않았나요?
            <br>혼자 산다고, 이제 곧 이사 갈 테고,
            <br>비용이 많이 들고, 설치하기 번거로우니까.
            <br>우리는 이런 걱정 없이 생활의 불편을
            <br>해소하고 누구나 소유하고 활용할 수 있는
            <br>제품을 연구합니다.
          </p>
        </div>
        <div class="m-about-description-container">
          <h2>더 나은 1인의 삶을 위해
            <br>아이오는 시작되었습니다
          </h2>
          <p>아이오는 1인 가구를 위한 ‘제품’을
            <br>만드는 회사가 아닙니다.
            <br>우리는 우리가 만드는 제품으로 1인의 삶이
            <br>쉽고 간결해지기를 바랍니다.
            <br>나아가 우리들 개개인이 더욱 더 가치있고
            <br>주체적인 삶을 살기를 희망합니다.
          </p>
        </div>
        <div class="m-about-description-container">
          <h2>고객지원</h2>
          <p>02-6212-9272
            <br>help@switcher.co.kr
            <br>MON-THU 10:00 - 18:00
            <br>
          </p>
        </div>
      </section>
      <section class="m-about-bottom">
        <div class="m-about-bottom-container">
          <p>아이오와 더 긴밀히 소통하고 싶다면</p>
          <a href="https://www.facebook.com/switcher.io/" target="_blank">
            <img src="@/assets/footer/facebook.png" alt>
          </a>
          <a href="https://cafe.naver.com/switcherofio" target="_blank">
            <img src="@/assets/footer/naver-cafe.png" alt>
          </a>
        </div>
        <div class="m-about-bottom-container">
          <p>아이오의 일상이 궁금하다면</p>
          <a href="https://www.instagram.com/smarthome_io/" target="_blank">
            <img src="@/assets/footer/instagram.png" alt>
          </a>
        </div>
        <div class="m-about-bottom-container">
          <p>제품 체험 중 궁금한 점이 생기면</p>
          <a href="https://pf.kakao.com/_uuXmV" target="_blank">
            <img src="@/assets/footer/kakao-talk.png" alt>
          </a>
        </div>
      </section>
    </div>
    <app-footer></app-footer>
  </div>
</template>

<script>
import AppFooter from './AppFooter'

export default {
  name: 'about',
  components: { AppFooter }
}
</script>
<style scoped>
.about-head-title {
  background-color: #ffffff;
  height: 60px;
  padding: 20px 0px 0px 0px;
}
.about-head-title h1 {
  font-size: 20px;
  font-weight: bold;
  text-align: left;
}
.about-hero {
  background: url('../assets/about-hero.png') no-repeat center center;
  background-size: cover;
  min-height: 500px;
  display: flex;
  align-items: center;
}
.about-hero span {
  font-size: 24px;
  font-weight: bold;
}

.main-title-wrapper {
  text-align: left;
  margin-left: 10%;
}

.about-description-container {
  margin-top: 100px;
  display: inline-flex;
  justify-content: space-between;
  width: 60%;
}
.about-description-container h2 {
  font-size: 20px;
  line-height: 1.5;
  text-align: left;
  width: 30%;
}
.about-description-container p {
  font-size: 16px;
  font-weight: 400;
  line-height: 1.62;
  color: #3d4953;
  text-align: left;
  width: 70%;
}
.about-bottom {
  margin-top: 50px;
  width: 75%;
  background-color: #fafafa;
  display: inline-flex;
  justify-content: space-evenly;
  padding-top: 45px;
  padding-bottom: 45px;
  font-size: 16px;
}

.about-bottom img {
  width: 26px;
  height: 26px;
}

.m-about-hero {
  background: url('../assets/about/m-about-hero.png') no-repeat center center;
  background-size: cover;
  min-height: 469px;
  text-align: left;
  padding: 41px 0px 0px 26px;
}

.m-about-hero h1 {
  font-size: 18px !important;
  font-weight: bold;
}
.m-about-hero p {
  margin-top: 24px;
}
.m-about-description-wrapper {
  padding-left: 25px;
}
.m-about-description-container {
  text-align: left;
  margin-top: 70px;
}
.m-about-description-container h2 {
  font-size: 18px;
  line-height: 1.56;
}

.m-about-description-container p {
  font-size: 14px;
  line-height: 1.71;
}

.m-about-bottom-container {
  text-align: left;
  margin-top: 30px;
}
.m-about-bottom {
  background-color: #fafafa;
  padding: 50px 0px 50px 25px;
}

.m-about-bottom img {
  width: 26px;
  height: 26px;
}
</style>



// WEBPACK FOOTER //
// src/components/About.vue